// extracted by mini-css-extract-plugin
module.exports = {"text":"_6c97079b1b--text--3D-qc","link":"_6c97079b1b--link--OEJWn"};